// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --lightningcss-light: initial;
  --lightningcss-dark: ;
  color-scheme: light dark;
}

@media (prefers-color-scheme: dark) {
  :root {
    --lightningcss-light: ;
    --lightningcss-dark: initial;
  }
}

:root, [data-theme="default"] {
  --lightningcss-light: initial;
  --lightningcss-dark: ;
  color-scheme: light;
}

[data-theme="dark"] {
  --lightningcss-light: ;
  --lightningcss-dark: initial;
  color-scheme: dark;
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/themes.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAJA;EAAA;IAQI,sBAAsB;IACtB,4BAA4B;EAC9B;AACF;;AAPA;EAUE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;;AATA;EAYE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB","sourcesContent":[":root {\n  color-scheme: light dark;\n}\n\n:root, [data-theme=\"default\"] {\n  color-scheme: light;\n}\n\n[data-theme=\"dark\"] {\n  color-scheme: dark;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
